export default class FnEditorSelection {
    constructor(startId, startPosition, endId, endPosition) {
        this.startId = startId;
        this.startPosition = startPosition;
        this.endId = endId;
        this.endPosition = endPosition;
    }
    isCursor() {
        if (!this.endId) {
            return true;
        }
        return this.endId === this.startId && this.startPosition === this.endPosition;
    }
    multipleElementsSelected() {
        return !!this.endId && this.endId !== this.startId;
    }
    getRaw() {
        return {
            startId: this.startId,
            startPosition: this.startPosition,
            endId: this.endId,
            endPosition: this.endPosition,
        };
    }
    static fromRaw(rawData) {
        return new FnEditorSelection(rawData.startId, rawData.startPosition, rawData.endId, rawData.endPosition);
    }
}
